import {
  Select,
  Option,
  Form,
  Button,
  ModalManagerContext,
  Grid,
  Input,
  TextArea,
  Text,
  Flex,
} from '@pega/cosmos-react-core';
import React, { useContext, useState } from 'react';
import { languageMapping } from '../../../../constants/languageCodes';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

interface AddChatHeadingModalProps {
  addHeading: (l: string, h: string) => void;
  languages: string[];
  showTextArea?: boolean;
}

const AddChatHeadingModal: React.FC<AddChatHeadingModalProps> = (props) => {
  const { languages, addHeading, showTextArea } = props;
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const [chatHeading, setChatHeading] = useState('');
  const translate = useLocalTranslation();
  const { ModalContext } = useContext(ModalManagerContext);
  const { dismiss } = useContext(ModalContext);
  const [specialNoteError, setSpecialNoteError] = useState(false);
  const addChatHeading = () => {
    if (showTextArea && specialNoteError) return;
    if (typeof chatHeading.trim() === 'string') {
      addHeading(selectedLanguage, chatHeading);
      dismiss();
    }
  };
  const updateSpecialNote = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const text = e.target.value;
    setChatHeading(text);
    if (text?.length < 1 || text?.length > 350) {
      setSpecialNoteError(true);
    } else {
      setSpecialNoteError(false);
    }
  };

  const updateChatTitle = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChatHeading(e.target.value);
  };

  const actions = (
    <>
      <Button onClick={dismiss}>{translate('cancel')}</Button>
      <Button variant="primary" onClick={addChatHeading}>
        {translate('ok')}
      </Button>
    </>
  );
  return (
    <Form actions={actions}>
      <Grid
        container={{
          cols: 'repeat(3, 30% 60% 10%)',
          gap: 2,
          alignItems: showTextArea ? 'start' : 'end',
        }}
      >
        <Select
          label={translate('language')}
          value={selectedLanguage}
          onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
            setSelectedLanguage(e.target.value);
          }}
        >
          {languages.map((lang) => (
            <Option key={lang} value={lang}>
              {languageMapping[lang]}
            </Option>
          ))}
        </Select>
        {showTextArea ? (
          <Flex>
            <TextArea
              special_note
              label={translate('special_note')}
              value={chatHeading}
              onChange={updateSpecialNote}
              required={true}
              autoResize={true}
              status={specialNoteError ? 'error' : undefined}
            />
            {specialNoteError && <Text status="error">{translate('special_note_validation_error')}</Text>}
          </Flex>
        ) : (
          <Input
            label={translate('chat_heading')}
            type="text"
            name={`heading`}
            autoComplete="off"
            value={chatHeading}
            onChange={updateChatTitle}
          />
        )}
      </Grid>
    </Form>
  );
};

export default AddChatHeadingModal;
